module.exports = __webpack_public_path__ + "static/media/opening-illus.2e65fd9c.png";